import * as core from '../../../../../../../core'
import * as billabilityCalculator from '../billability-calculator'

export const RESOURCE = {
  payload: {
    alias: 'billability-calculator',
    appAlias: billabilityCalculator.RESOURCE.payload.alias,
    description: 'Use to calculate billability.',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Calculator',
    page: { alias: 'billability-calculator' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
